"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getByDotKey = void 0;
/** extracts by dot, lastVal is currently unnessasary but retained for likely future use */
const getByDotKey = (key, object) => {
    const keyParts = key.split('.');
    const parsed = keyParts.reduce((a, k) => {
        if (a.currentOb && (!!a.currentOb[k] || typeof a.currentOb[k] === 'boolean' || typeof a.currentOb[k] === 'number')) {
            a = { currentOb: a.currentOb[k], lastVal: a.currentOb[k] };
        }
        else {
            a = { currentOb: null, lastVal: null };
        }
        return a;
    }, { currentOb: object, lastVal: null });
    return parsed.lastVal;
};
exports.getByDotKey = getByDotKey;
